export const getFormattedPrice = (number) => {
  if (isNaN(number) || !number) return "";

  // Convert to number if it's a string
  const num = typeof number === "string" ? parseFloat(number) : number;

  // Check if the number has significant decimal places
  const hasDecimals = num % 1 !== 0;

  return num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  });
};
